/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

// Stesse regole dell'app: si modifica o elimina una spesa non bloccata
// (`locked`) che non sta in una nota, oppure sta in una nota in bozza o
// respinta; finance può sempre. Il server decide comunque (403 o 422).
const EDITABLE_REPORT_STATUSES = ['DRAFT', 'REJECTED'];

export interface ExpenseForRules {
  locked: boolean;
  empNumber: number;
  report?: {status: string} | null;
}

export const canEditExpense = (
  expense: ExpenseForRules,
  me: {isFinance: boolean; empNumber: number | null} | null,
): boolean => {
  if (!me) return false;
  if (me.isFinance) return true;
  if (expense.empNumber !== me.empNumber) return false;
  if (expense.locked) return false;
  return (
    !expense.report || EDITABLE_REPORT_STATUSES.includes(expense.report.status)
  );
};
